import React, { useEffect, useRef, useState } from "react";
import Moment from "react-moment";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux/es/exports";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import pdf from "../../../assets/images/img-icons/pdf.png";
import { APP_URL } from "../../../constants";
import MakeUser from "../../../pages/admin/customer/MakeUser";
import Success from "../../../pages/admin/customer/Success";
import {
  getAllStaffs,
  resetAppId,
  resetStaffInformation,
  resetStaffStatus,
  setAppId,
} from "../../../redux/slice/staff/staffSlice";
import PaginationLinks from "../../pagination/PaginationLinks";
import { isEmptyObject } from "./../../../utils/validators/validators";

const StaffTable = () => {
  const { staff_list, app_id, isSuccess, isUpdated, isLoading } = useSelector(
    (state) => state.staff
  );
  const { user_permissions } = useSelector((state) => state.auth?.user);
  const [pageNumber, setPageNumber] = useState(1);
  const [filterBy, setFilterBy] = useState("");
  const [filteredData, setFilteredData] = useState(staff_list?.data);
  const [selectedUser, setSelectedUser] = useState(null);
  const [hasViewStaff, setHasViewStaff] = useState();
  const [hasMakeUser, setHasMakeUser] = useState();

  let makeUserRef = useRef("");

  const handleSelectUser = (user_id) => {
    setSelectedUser(user_id);
    makeUserRef?.current?.click();
  };

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // fetch staff list on click of pagination links
  const fetchStaffsHandler = async (pageNum) => {
    setPageNumber(pageNum);
    dispatch(getAllStaffs({ pageNumber: pageNum, search: "" }));
  };

  // fetch sfaff list on page load
  useEffect(() => {
    fetchStaffsHandler(pageNumber);
  }, [dispatch, pageNumber]);

  // reset status variables
  useEffect(() => {
    if (isUpdated) {
      fetchStaffsHandler(pageNumber);
      dispatch(resetStaffStatus());
    }
    if (isSuccess) {
      dispatch(resetStaffInformation());
      dispatch(resetStaffStatus());
    }
  }, [isSuccess, isUpdated]);

  // pagination route page navigator
  useEffect(() => {
    navigate({
      pathname: "/admin/list-of-staffs",
      search: `?page=${pageNumber}`,
    });
  }, [staff_list]);

  //  filter staff list
  useEffect(() => {
    if (isSuccess) {
      setFilteredData(staff_list.paginated.data);
    }
    if (filterBy == "all") {
      setFilteredData(staff_list.paginated.data);
    } else if (filterBy == "pending") {
      let pendingItems = staff_list.paginated.data.filter(
        (f) => f.status === "pending"
      );
      setFilteredData(pendingItems);
    } else if (filterBy == "completed") {
      let completedItems = staff_list.paginated.data.filter(
        (f) => f.status === "completed"
      );
      setFilteredData(completedItems);
    }
  }, [filterBy, isSuccess]);

  useEffect(() => {
    setHasViewStaff(
      user_permissions?.some(
        (permission) => permission.name === "view staff details"
      )
    );
    setHasMakeUser(
      user_permissions?.some(
        (permission) => permission.name === "make staff user"
      )
    );
    dispatch(resetAppId());
  }, [dispatch, user_permissions]);

  const continueRegistrationHandler = (staffId) => {
    dispatch(setAppId(staffId));
    navigate("/admin/add-staff", { state: { from: location }, replace: true });
  };

  return (
    <div>
      {staff_list?.data?.length === 0 ? (
        <div className='alert alert-info rounded-0 p-3'>No Record Found</div>
      ) : (
        <div className='row'>
          <div className='col-12'>
            <div className='row d-flex justify-content-between'>
              <div className='col-sm-5 col-md-6 mb-0'>
                <ul className='nav nav-tabs nav-bordered'>
                  <li className='nav-item'>
                    <a
                      onClick={() => setFilterBy("all")}
                      href='#hint-emoji-preview'
                      data-bs-toggle='tab'
                      aria-expanded='false'
                      className='nav-link active'
                    >
                      All
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      onClick={() => setFilterBy("completed")}
                      href='#hint-emoji-code'
                      data-bs-toggle='tab'
                      aria-expanded='true'
                      className='nav-link'
                    >
                      Completed
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      onClick={() => setFilterBy("pending")}
                      href='#hint-emoji-code'
                      data-bs-toggle='tab'
                      aria-expanded='true'
                      className='nav-link'
                    >
                      In progress
                    </a>
                  </li>
                </ul>
              </div>
              {/* <div className="col-md-4 mt-2">
                        <form className="d-flex">
                            <button className="btn" type="submit">Search</button>
                            <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search"/>
                        </form>                                    
                    </div> */}
              {/* <div className='col-md-4 d-flex gap-2 align-items-center'>
                <div id='tooltip-container3'>
                  <button
                    href='#'
                    onClick={() => window.location.reload()}
                    className='btn btn-info p-1 px-2 text-white pe-auto'
                    title='refresh to get all actions'
                    data-bs-container='#tooltip-container3'
                    data-bs-toggle='tooltip'
                    data-bs-html='true'
                  >
                    <i className='mdi mdi-reload'></i>
                  </button>
                </div>
                <div className='px-2 py-1 border'>
                  <span className='bg-info p-1  me-2 text-white'>
                    Export to
                  </span>
                  <a href='#' id='btnExport' className='mx-0'>
                    <img src={pdf} alt='' />
                  </a>
                  <a href='#'>
                    <img src='{excel}' alt='' />
                  </a>
                  <a href='#'>
                    <img src='{doc}' alt='' />
                  </a>
                </div>
              </div> */}
            </div>
            <div className='table-responsive'>
              <div
                id='products-datatable_wrapper'
                className='dataTables_wrapper dt-bootstrap5 no-footer no-dataTable-length'
              >
                <div className='row'>
                  <div className='col-sm-12'>
                    <table
                      className='table table-centered table-striped dt-responsive nowrap w-100 dataTable no-footer dtr-inline collapsed'
                      // id='tableDataset'
                      data-toggle='table'
                      id='tableStaffs'
                      data-show-export='true'
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "27.6px" }}>#</th>
                          <th style={{ width: "20.8px" }}>Status</th>
                          <th style={{ width: "114.8px" }}>Full Names</th>
                          <th style={{ width: "117.8px" }}>Gender</th>
                          <th style={{ width: "106.8px" }}>L.g.a</th>
                          <th style={{ width: "96.8px" }}>State</th>
                          <th style={{ width: "96.8px" }}>Office</th>
                          <th style={{ width: "75.6px" }}>Date Registered</th>
                          <th style={{ width: "75.6px" }}>Active</th>
                          {hasViewStaff && (
                            <th style={{ width: "55.8px" }}>Action</th>
                          )}
                          {hasMakeUser && <th style={{ width: "55.8px" }}></th>}
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData &&
                          filteredData?.map((staff, index) => (
                            <tr key={staff.id}>
                              <td>{index + 1}</td>
                              <td>
                                <span
                                  className={`badge badge-${
                                    staff.status === "completed"
                                      ? "success"
                                      : "warning"
                                  }-lighten fw-normal rounded-4`}
                                  style={{
                                    fontSize: "10px",
                                    padding: "5px 18px",
                                  }}
                                >
                                  {staff.status}
                                </span>
                              </td>
                              <td className='table-user'>
                                {staff?.image?.includes("res.cloudinary") ? (
                                  <img
                                    src={staff?.image}
                                    alt='table-user'
                                    className='me-2 rounded-circle'
                                  />
                                ) : (
                                  <img
                                    src={`${APP_URL}${staff.image}`}
                                    alt='table-user'
                                    className='me-2 rounded-circle'
                                  />
                                )}
                                <a
                                  href='#'
                                  className='text-body fw-semibold'
                                >{`${
                                  staff.first_name + " " + staff.last_name
                                }`}</a>
                              </td>
                              <td>{staff.gender}</td>
                              <td>{staff.l_g_a}</td>
                              <td>{staff.state}</td>
                              <td>{staff.office_name}</td>
                              <td>
                                <Moment
                                  format='DD-MM-YYYY'
                                  date={staff.created_at}
                                />
                              </td>
                              <td>
                                {staff?.active == "1" ? (
                                  <span
                                    className='badge badge-success-lighten rounded-4'
                                    style={{
                                      fontSize: "10px",
                                      padding: "5px 18px",
                                    }}
                                  >
                                    Active
                                  </span>
                                ) : (
                                  <span
                                    className='badge badge-danger-lighten rounded-4'
                                    style={{
                                      fontSize: "10px",
                                      padding: "5px 18px",
                                    }}
                                  >
                                    Inactive
                                  </span>
                                )}
                              </td>
                              <td>
                                <div>
                                  {hasViewStaff && (
                                    <Link
                                      to='/admin/staff/staff-profile'
                                      state={{ staff_id: staff.id }}
                                    >
                                      <i className='mdi mdi-eye text-primary fs-4 mx-2'></i>
                                    </Link>
                                  )}
                                  {staff.status === "pending" && (
                                    <button
                                      className='btn btn-info btn-sm rounded-'
                                      onClick={() =>
                                        continueRegistrationHandler(staff.id)
                                      }
                                    >
                                      <i className='uil uil-user-plus'></i>
                                      <span> continue</span>
                                    </button>
                                  )}
                                </div>
                              </td>
                              {hasMakeUser && (
                                <td>
                                  {staff?.is_user === "1" && <span>user</span>}
                                  {staff?.is_user === "0" && (
                                    <span
                                      className='btn btn-sm btn-primary'
                                      //  staff_data={staff}
                                      onClick={() =>
                                        handleSelectUser(staff?.id)
                                      }
                                    >
                                      make user
                                    </span>
                                  )}
                                  <span
                                    className='invisible'
                                    data-bs-toggle='modal'
                                    data-bs-target='#make_staff_user'
                                    ref={makeUserRef}
                                  ></span>
                                </td>
                              )}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* Pagination */}
              </div>
            </div>
          </div>
          <div className='row mt-4'>
            <div className='col-sm-12 col-md-6'>
              <div
                className='dataTables_info table-pages'
                id='products-datatable_info'
                role='status'
                aria-live='polite'
              >
                Showing offices {staff_list?.paginated?.from} to{" "}
                {staff_list?.paginated?.to} of {staff_list?.paginated?.total}
              </div>
            </div>
            <div className='col-sm-12 col-md-6'>
              <PaginationLinks
                paginationData={staff_list?.paginated}
                getNextPage={fetchStaffsHandler}
              />
            </div>
          </div>
          {/* <!-- end card--> */}
          <MakeUser
            modal_id='make_staff_user'
            user_id={selectedUser}
            setSelectedUser={setSelectedUser}
            // staff_data={staff_data}
          />
        </div>
      )}
    </div>
  );
};

export default StaffTable;
